// 3rd-party modules
import 'reflect-metadata';
import camelcaseKeys from 'camelcase-keys';
import { Expose, plainToInstance } from 'class-transformer';

export class AccountVpnConfigUrl {
  @Expose()
  public appName?: string;
  @Expose()
  public appPackage?: string;
  @Expose()
  public url?: string;
  @Expose()
  public downloadLink?: string;


  public static toClass(data: object) {
    //@ts-ignore
    return plainToInstance(AccountVpnConfigUrl, camelcaseKeys(data, { deep: true }), { excludeExtraneousValues: true });
  }

  public static toArrayOfClass(data: object[]) {
    //@ts-ignore
    return plainToInstance(AccountVpnConfigUrl, camelcaseKeys(data, { deep: true }) as AccountVpnConfigUrl[], { excludeExtraneousValues: false });
  }
}
